module.exports = __webpack_public_path__ + "img/太空舱.83899b21.png";